module.exports = '<svg width="43" height="32" viewBox="0 0 43 32"><path d="M2.326 0h38.029c2.113 0 2.924 2.668 1.857 4.145L23.299 30.698c-1.078 1.467-2.838 1.841-3.916.363L.47 3.959C-.608 2.486.225 0 2.327 0z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/down-1.js
// module id = 1104
// module chunks = 14